module.exports = __webpack_public_path__ + "img/device_1015_2.b6144de5.svg";